import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { inputCls } from "../components/admin/fields";
import { Loader2 } from "lucide-react";

export default function ResetPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Las contraseñas no coinciden.");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#071D4D] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white rounded-2xl p-7 shadow-2xl space-y-4">
        <h1 className="font-serif-display text-2xl font-bold text-[#071D4D]">Nueva contraseña</h1>
        {done ? (
          <>
            <p data-testid="reset-success" className="text-sm text-green-700">Contraseña actualizada correctamente.</p>
            <Link to="/admin" className="block text-center rounded-full bg-[#0057FF] text-white py-2.5 text-sm font-semibold">
              Ir a iniciar sesión
            </Link>
          </>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="reset-password-input" type="password" required minLength={8}
              placeholder="Nueva contraseña (mínimo 8 caracteres)" className={inputCls}
              value={password} onChange={(e) => setPassword(e.target.value)} />
            <input data-testid="reset-confirm-input" type="password" required
              placeholder="Confirma la contraseña" className={inputCls}
              value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            {error && <p data-testid="reset-error" className="text-sm text-red-600">{error}</p>}
            <button data-testid="reset-submit-button" disabled={busy}
              className="w-full rounded-full bg-[#0057FF] text-white py-2.5 text-sm font-semibold disabled:opacity-60 inline-flex items-center justify-center gap-2">
              {busy && <Loader2 size={15} className="animate-spin" />} Guardar contraseña
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
